<template>
    <v-card flat class="mb-4 py-4">
        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field
                        v-model="localFilters.numeroReserva"
                        label="Número da reserva:"
                        placeholder="Digite o número da reserva"
                        v-input-filter="[$filters.numeric]"
                        clearable
                        hide-details
                        outlined
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                        v-model="localFilters.numeroCota"
                        label="Número da cota:"
                        placeholder="Digite o número da cota"
                        v-input-filter="[$filters.numeric]"
                        clearable
                        hide-details
                        outlined
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                        v-model="localFilters.dataCriacao"
                        v-mask="'##/##/####'"
                        label="Data de criação:"
                        placeholder="Digite a data de criação da reserva"
                        clearable
                        hide-details
                        outlined
                        @input="handleDataCriacaoInput"
                        @click:clear="clearDataCriacao"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                        v-model="localFilters.dataExpiracao"
                        v-mask="'##/##/####'"
                        label="Data de expiração:"
                        placeholder="Digite a data de expiração da reserva"
                        clearable
                        hide-details
                        outlined
                        @input="handleDataExpiracaoInput"
                        @click:clear="clearDataExpiracao"
                />
            </v-col>
        </v-row>
        <v-row class="mt-4">
            <v-col cols="12" class="d-flex justify-space-between">
                <v-btn color="secondary" type="reset" class="mr-4" @click="resetFiltros">Limpar</v-btn>
                <v-btn color="primary" @click="filtrar">Filtrar</v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
  import { mask } from 'vue-the-mask'
  const filtroDefault = {
    numeroReserva: null,
    numeroCota: null,
    dataCriacao: null,
    dataExpiracao: null
  }

  export default {
    name: 'FiltroReservaMultiplas',
    directives: {
      mask
    },
    props: {
      value: {
        type: Object,
        default: () => ({ ...filtroDefault })
      }
    },
    data () {
      return {
        localFilters: { ...this.value }
      }
    },
    watch: {
      value (newVal) {
        this.localFilters = { ...newVal }
      }
    },
    methods: {
      emitFilters () {
        this.$emit('input', { ...this.localFilters })
      },
      resetFiltros () {
        this.localFilters = { ...filtroDefault }
        this.emitFilters()
        this.$emit('filtrar')
      },
      filtrar () {
        this.emitFilters()
        this.$emit('filtrar')
      },
      handleDataCriacaoInput (value) {
        if (value && value.length === 10) {
          const [dia, mes, ano] = value.split('/')
          const data = new Date(ano, mes - 1, dia)
          if (!isNaN(data.getTime())) {
            this.localFilters.dataCriacao = value
          }
        } else if (!value) {
          this.localFilters.dataCriacao = null
        }
      },
      handleDataExpiracaoInput (value) {
        if (value && value.length === 10) {
          const [dia, mes, ano] = value.split('/')
          const data = new Date(ano, mes - 1, dia)
          if (!isNaN(data.getTime())) {
            this.localFilters.dataExpiracao = value
          }
        } else if (!value) {
          this.localFilters.dataExpiracao = null
        }
      },
      clearDataCriacao () {
        this.localFilters.dataCriacao = null
        this.emitFilters()
      },
      clearDataExpiracao () {
        this.localFilters.dataExpiracao = null
        this.emitFilters()
      }
    }
  }
</script>

<style scoped>
.mb-4 {
    margin-bottom: 16px;
}
</style>
